@if (!hidePagination) {
  <div>
    <p-paginator
      #pg
      [first]="first"
      [rows]="rowsPerPage"
      [totalRecords]="totalCount"
      [showFirstLastIcon]="showFirstLastIcon"
      styleClass="paginator"
      (onPageChange)="onPageChange($event)">
    </p-paginator>
  </div>
}
